export default "__VITE_ASSET__CtCPaXOm__"